import { render, staticRenderFns } from "./PersonPhotoMatch.vue?vue&type=template&id=2e8696c2&scoped=true&"
import script from "./PersonPhotoMatch.vue?vue&type=script&lang=js&"
export * from "./PersonPhotoMatch.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhotoMatch.vue?vue&type=style&index=0&id=2e8696c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8696c2",
  null
  
)

export default component.exports